import getLogo from '../service/logoFactory';
import getEnv from '../service/getEnv';

const logo = getLogo(getEnv());

// Previous implementation
// const logo = getLogo(process.env.REACT_APP_ENV);

export const Container = {
	fontFamily: `-apple-system,
                BlinkMacSystemFont,
                "Segoe UI",
                Roboto,
                Helvetica,
                Arial,
                sans-serif`,
	fontSize: '14px',
	lineHeight: '18px',
	backgroundColor: 'white',
	textAlign: 'left'
};

export const NavBar = {
	position: 'fixed',
	borderBottom: '1px solid rgba(0,0,0,.0975)',
	top: 0,
	width: '100%',
	zIndex: 1,
	backgroundColor: '#fff',
	height: '77px',
	fontWeight: '300'
};


export const NavRight = {
	textAlign: 'right'
};

export const Nav = {
	padding: '26px 40px'
};

export const NavItem = {
	display: 'inline-block',
	padding: '10px 5px',
	lineHeight: '20px'
};

export const NavButton = {
	display: 'inline-block',
	padding: '6px 12px',
	fontSize: '14px',
	fontWeight: 300,
	textAlign: 'center',
	whiteSpace: 'nowrap',
	verticalAlign: 'middle',
	touchAction: 'manipulation',
	cursor: 'pointer',
	userSelect: 'none',
	backgroundImage: 'none',
	border: '1px solid #aaa',
	borderRadius: '4px',
	color: '#333',
	backgroundColor: '#fff'
};

export const FormContainer = {
	textAlign: 'center'
};

/*const beforeImg = React.createElement('img', {
	src: screenshot5,
	style: {
		width: '216px',
		marginTop: '87px',
		marginLeft: '79px',
		height: '393px'
	}
});*/

export const FormSection = {
	margin: '0 0 10px',
	color: '#262626',
	backgroundColor: '#fff',
	border: '1px solid #e6e6e6',
	borderRadius: '1px',
	textAlign: 'center',
	width: '350px',
	display: 'inline-block',
	verticalAlign: 'middle',
	minWidth: 'auto',
	/*before: {
		content: beforeImg,
		display: 'inline-block',
		width: '400px',
		height: '560px',
		verticalAlign: 'middle',
		backgroundImage: 'url(' + home_phone + ')',
		backgroundSize: '400px 560px'
	}*/
};

export const ErrorSection = {
	marginBottom: '20px',
	color: '#fff',
	backgroundColor: '#f0ad4e',
	border: '1px solid #eea236',
	borderRadius: '4px',
	textAlign: 'left'
};

export const SectionHeader = {
	margin: '0px auto 25px',
	overflow: 'hidden',
	backgroundColor: 'white'
};

let SectionHeaderContent = {
	height: '90px',
	width: '200px',
	display: 'inline-block',
	textIndent: '0%',
	whiteSpace: 'nowrap',
	backgroundImage: 'url(' + logo + ')',
	backgroundSize: '100%',
	backgroundRepeat: 'no-repeat',
	backgroundPosition: '0px 30px'
};

const env = getEnv();

if (env === 'roomspace' || env === 'citystayapartment' || env === "bnbme") {
	SectionHeaderContent.backgroundSize = 'auto';
	SectionHeaderContent.height = '118px';
	SectionHeaderContent.backgroundPosition = '50% 30px';
}

if (env === 'citystayapartment') {
	SectionHeaderContent.height = '118px';
}

if (env === 'roomspace') {
	SectionHeaderContent.height = '122px';
}




export const SectionHeaderContentFinal = SectionHeaderContent;

export const SectionFooter = {
	fontSize: '14px',
	textAlign: 'left',
	color: '##262626',
	backgroundColor: '#fff',
	margin: '10px 1px 10px',
	padding: '20px 15px 10px 15px',
	boxSizing: 'border-box'
};

export const SectionFooterPrimaryContent = {
	width: '100%'
};

export const SectionBody = {
	padding: '0',
	margin: '0',
	minHeight: '240px'
};

export const FormRow = {
	margin: '0 40px 6px',
	textAlign: 'left'
};

export const ActionRow = {
	margin: '0 40px 6px'
};

export const Input = {
	fontFamily: `-apple-system,
                BlinkMacSystemFont,
                "Segoe UI",
                Roboto,
                Helvetica,
                Arial,
                sans-serif`,
	display: 'block',
	width: '100%',
	background: '#fafafa',
	padding: '9px 0 7px 8px',
	border: '1px solid #efefef',
	borderRadius: '3px',
	fontSize: '16px',
	lineHeight: '18px',
	boxSizing: 'border-box'
};

export const Button = {
	display: 'inline-block',
	fontSize: '14px',
	fontWeight: '600',
	lineHeight: '26px',
	padding: '0 8px',
	marginTop: '8px',
	marginBottom: '8px',
	border: '1px solid',
	borderRadius: '3px',
	color: '#fff',
	backgroundColor: '#337ab7',
	borderColor: '#337ab7',
	width: '100%'
};

export const SignInButton = {
	display: 'inline-block',
	fontSize: '14px',
	fontWeight: '600',
	lineHeight: '26px',
	padding: '0 8px',
	margin: '8px 0',
	border: '1px solid',
	borderRadius: '3px',
	color: '#fff',
	backgroundColor: '#3897f0',
	borderColor: '#3897f0',
	width: '100%',
	'#google_signin_btn': { display: 'none' }
};

export const Space = {
	display: 'none'
};

export const A = {
	color: '#3897f0'
};

export const Pre = {
	overflow: 'auto',
	fontFamily: `Menlo,
                Monaco,
                Consolas,
                "Courier New",
                monospace`,
	display: 'block',
	padding: '9.5px',
	margin: '0 0 10px',
	fontSize: '13px',
	lineHeight: '1.42857143',
	color: '#333',
	wordBreak: 'break-all',
	wordWrap: 'break-word',
	backgroundColor: '#f5f5f5',
	border: '1px solid #ccc',
	borderRadius: '4px'
};

export const Col6 = {
	display: 'inline-block',
	width: '50%'
};

export const inputLabel = {
	textAlign: 'left'
};

const Instagram = {
	container: Container,

	navBar: NavBar,
	nav: Nav,
	navRight: NavRight,
	navItem: NavItem,
	navButton: NavButton,

	formContainer: FormContainer,
	formSection: FormSection,
	errorSection: ErrorSection,
	sectionHeader: SectionHeader,
	sectionHeaderContent: SectionHeaderContentFinal,
	sectionBody: SectionBody,
	sectionFooter: SectionFooter,
	sectionFooterPrimaryContent: SectionFooterPrimaryContent,
	formRow: FormRow,
	actionRow: ActionRow,

	space: Space,

	signInButton: SignInButton,

	input: Input,
	inputLabel: inputLabel,
	button: Button,
	a: A,
	pre: Pre,

	col6: Col6
};

export default Instagram;


//the collective login page styling 
if(env === 'thecollective') {
	SectionHeaderContent.backgroundSize = '40%';
	SectionHeaderContent.height = '120px';
	SectionHeaderContent.backgroundPosition = '50% 35px';
	Button.backgroundColor = 'black';
	Button.borderColor = 'black';
	Button.borderRadius = '20px';
	Button.fontFamily = 'TheCollectiveBecome';
	SignInButton.fontFamily = 'TheCollectiveBecome'
	Container.fontFamily = "TheCollectiveBecome";
	Container.backgroundColor = '#ffffff00';
	var element1 = document.createElement("div");
    element1.classList.add("a1");
	var element2 = document.createElement("div");
		element2.classList.add("greenshape");
  document.getElementsByTagName("BODY")[0].appendChild(element1);
	document.getElementsByTagName("BODY")[0].appendChild(element2);
	element1.style.backgroundImage = "url('https://s3-eu-west-1.amazonaws.com/cdn.resharmonics.com/thecollective/images/yellow_pattern.svg')";
	element1.style.position = "fixed";
	element1.style.zIndex = "-10";
	element1.style.top = "0";
	element1.style.left = "-15%";
	element1.style.width = "100%";
	element1.style.height = "986px";
	element1.style.backgroundRepeat = "no-repeat";
	element1.style.backgroundPosition = "94% 112%";
	element1.style.backgroundColor = "white";

	element2.style.position = "fixed";
	element2.style.zIndex = "-10";
	element2.style.top = "660px";
	element2.style.right = "0";
	element2.style.width = "346px";
	element2.style.height = "577px";
	element2.style.backgroundRepeat = "no-repeat";
	element2.style.backgroundImage = "url('https://s3-eu-west-1.amazonaws.com/cdn.resharmonics.com/thecollective/images/green_pattern.svg')";
}
